import React from 'react'
import {
  Button,
  Dialog,
  Divider,
  Grid,
  Link,
  Typography,
} from '@material-ui/core'
import { Close as CloseIcon, Share as ShareIcon } from '@material-ui/icons'
import ShareIcons from './ShareIcons'
import { withStyles } from '@material-ui/core'
import { styles } from '../styles/js/dialogPhoto'

const DialogPhotoComponent = ({
  classes,
  dialog,
  handleClose,
  reportPhoto,
  pageProps,
}) => {
  return (
    <Dialog
      onClose={handleClose}
      open={dialog.isOpen}
      fullWidth={true}
      maxWidth={'sm'}
      PaperProps={{
        className: classes.root,
      }}
      scroll='body'
    >
      <Button
        className={classes.closeButton}
        onClick={handleClose}
        color='primary'
        variant='contained'
      >
        <CloseIcon style={{ color: '#fff' }} />
      </Button>
      {dialog.data && (
        <>
          <img
            alt={`Foto de ${dialog.data.telespectador}`}
            src={dialog.data.url}
            className={classes.photo}
          />
          <Typography variant='h3' className={classes.title}>
            {dialog.data.telespectador}
          </Typography>
          <Divider />
          <Grid
            container
            justifyContent='space-between'
            className={classes.socialSection}
          >
            <Grid item xs={12}>
              {navigator.userAgent.split('/')[0] === 'Você na RPC' ? (
                <Typography variant='h6' style={{ textAlign: 'center' }}>
                  Compartilhe esta foto usando o botão{' '}
                  <ShareIcon fontSize='small' className={classes.shareIcon} />{' '}
                  no canto superior direito
                </Typography>
              ) : (
                <ShareIcons
                  size={'3x'}
                  justifyContent='space-evenly'
                  telespectador={dialog.data.telespectador}
                  mobileXs
                  pageProps={pageProps}
                />
              )}
            </Grid>

            <Grid item xs={12}>
              <Grid container justifyContent='center'>
                <Typography
                  variant='subtitle2'
                  className={classes.inappropriateContent}
                >
                  Este conteúdo é inapropriado?{' '}
                  <Link
                    href={'#'}
                    className={classes.inappropriateContentLink}
                    onClick={reportPhoto}
                  >
                    Denuncie!
                  </Link>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </Dialog>
  )
}

export default withStyles(styles)(DialogPhotoComponent)
